export const stripTags = html => html?.replace(/<[^>]*>?/gm, '');
